<template>
  <div>
    <div v-for="company in companies" :key="company.code">
      <p>{{ company.name }}</p>
      <ul>
        <li v-for="file in company.files" :key="file">
          <a @click.prevent="download(file.key)" href="#">{{
            file.filename
          }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
const findCompany = (companies, companyCode) => {
  return companies.find(c => c.code === companyCode)
}

const parsePath = path => {
  const components = path.split('/')
  return {
    key: path,
    filename: components[components.length - 1],
  }
}

export default {
  data() {
    return {
      companies: [],
    }
  },
  methods: {
    async download(file) {
      const url = await this.$repositories
        .get('linkLegacy')
        .getDownloadLink(file)
      window.open(url)
    },
  },
  async mounted() {
    const companies = this.$store.state.companies
    const response = await this.$repositories.get('linkLegacy').list()

    const data = []

    for (const [companyCode, files] of Object.entries(response)) {
      data.push({
        code: companyCode,
        name: findCompany(companies, companyCode).name,
        files: [...files.map(parsePath).reverse()],
      })
    }

    this.companies = data
  },
}
</script>
